import React from "react";
import "./App.css";

import AppScreenshotsModal from "../AppScreenshotsModal/AppScreenshotsModal";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.thumbnails = this.props.screenshots.map((screenshot, index) => (
      <img
        key={screenshot.src}
        className="Thumbnail"
        src={
          process.env.PUBLIC_URL +
          "/assets/" +
          this.props.slug +
          "/thumb/" +
          screenshot.src +
          ".png"
        }
        alt={screenshot.alt}
        title={screenshot.alt}
        onClick={() => this.handleScreenshotClick(index)}
      />
    ));
  }

  handlePrevClick() {
    if (this.state.modalIndex !== 0)
      this.setState({
        modalIndex: this.state.modalIndex - 1,
      });
  }

  handleNextClick() {
    if (this.state.modalIndex !== this.props.screenshots.length - 1)
      this.setState({
        modalIndex: this.state.modalIndex + 1,
      });
  }

  handleCloseClick() {
    this.setState({
      showModal: false,
    });
  }

  handleScreenshotClick(index) {
    this.setState({
      showModal: true,
      modalIndex: index,
    });
  }

  render() {
    return (
      <div className="App" ref={(container) => (this.container = container)}>
        <div className="AppHeader">
          <img
            src={
              process.env.PUBLIC_URL +
              "/assets/" +
              this.props.slug +
              "/icon.png"
            }
            alt={this.props.name}
            title={this.props.name}
          />
          <h4>{this.props.name}</h4>
        </div>
        <p className="AppLinks">
          {this.props.id.web && (
            <a
              href={this.props.id.web}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/common/web-app-badge.png`}
                alt="Visit web app"
                title="Visit web app"
              />
            </a>
          )}
          {this.props.id.ios && (
            <a href={"https://itunes.apple.com/us/app/id" + this.props.id.ios}>
              <img
                src={`${process.env.PUBLIC_URL}/assets/common/app-store-badge.png`}
                alt="Download on the App Store"
                title="Download on the App Store"
              />
            </a>
          )}
          {this.props.id.android && (
            <a
              href={
                "https://play.google.com/store/apps/details?id=" +
                this.props.id.android
              }
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/common/google-play-badge.png`}
                alt="Download on Google Play"
                title="Download on Google Play"
              />
            </a>
          )}
        </p>
        {this.props.email && (
          <p className="AppEmail">
            <a href={`mailto:${this.props.email}`}>
              <i className="fa fa-envelope fa-lg fa-fw" />
              {this.props.email}
            </a>
          </p>
        )}
        <p className="AppDescription">{this.props.description}</p>
        <div className="AppScreenshots">{this.thumbnails}</div>
        <AppScreenshotsModal
          {...this.props}
          showModal={this.state.showModal}
          modalIndex={this.state.modalIndex}
          onPrevClick={() => this.handlePrevClick()}
          onNextClick={() => this.handleNextClick()}
          onCloseClick={() => this.handleCloseClick()}
        />
      </div>
    );
  }

  componentDidMount() {
    if (this.props.match) {
      this.props.changeSection();
      setTimeout(() => {
        this.container.scrollIntoView();
      }, 300);
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js